"use strict";

require("core-js/modules/es.object.from-entries.js");

var _regeneratorRuntime = require("/home/vsts/work/1/s/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preparePagefindItem = exports.prepareFacets = exports.isAlgoliaDomain = exports.interceptXMLHttpRequest = exports.extractIndexFromUrl = exports.extractFieldsFromQuery = void 0;

var constants = _interopRequireWildcard(require("../constants"));

var _algoliaTransformers = require("./algolia-transformers");

var _filtersParser = require("./filters-parser");

var _log = require("./log");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var isAlgoliaDomain = function isAlgoliaDomain(url) {
  return constants.algoliaDomains.some(function (domain) {
    return url.includes(domain);
  });
};

exports.isAlgoliaDomain = isAlgoliaDomain;

var extractIndexFromUrl = function extractIndexFromUrl(url) {
  var regex = /indexes\/(.*?)\/query/;
  var match = url.match(regex);
  return match ? match[1] : null;
};

exports.extractIndexFromUrl = extractIndexFromUrl;

var preparePagefindItem = function preparePagefindItem(_ref) {
  var data = _ref.data,
      params = _ref.params,
      query = _ref.query,
      _ref$facets = _ref.facets,
      facets = _ref$facets === void 0 ? {} : _ref$facets;
  var itemHits = data.map(function (item) {
    return _objectSpread(_objectSpread({}, JSON.parse(item.meta.custom)), {}, {
      _highlightResult: {},
      _snippetResult: JSON.parse(item.content)
    });
  });
  return {
    hitsPerPage: constants.maxItemsNumber,
    nbHits: itemHits.length,
    hits: itemHits,
    nbPages: 1,
    page: 0,
    processingTimeMS: 1,
    renderingContent: {},
    serverTimeMS: 0,
    exhaustiveNbHits: true,
    exhaustiveTypo: true,
    exhaustive: {
      nbHits: true,
      typo: true
    },
    params: params,
    query: query,
    facets: facets
  };
};

exports.preparePagefindItem = preparePagefindItem;

var prepareFacets = function prepareFacets(_ref2) {
  var fields = _ref2.fields,
      pagefindFilters = _ref2.pagefindFilters;
  return Object.fromEntries(Object.entries(pagefindFilters).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return fields.includes(key);
  }));
};

exports.prepareFacets = prepareFacets;

var extractFieldsFromQuery = function extractFieldsFromQuery(value) {
  var _value$match;

  return _toConsumableArray(new Set((_value$match = value.match(/[\w|.]*:/gim)) === null || _value$match === void 0 ? void 0 : _value$match.map(function (item) {
    return item.replace(':', '');
  })));
};

exports.extractFieldsFromQuery = extractFieldsFromQuery;

var parseToAlgoliaResponse = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
    var body, url, _window3, _window3$pagefind, _window4, algoliaIndexName, results, query, facetFilters, tagFilters, search, data, pagefindFilters, filterFields, facets;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            body = _ref5.body, url = _ref5.url;
            algoliaIndexName = extractIndexFromUrl(url);

            if (algoliaIndexName) {
              _context4.next = 7;
              break;
            }

            _context4.next = 5;
            return Promise.all(body.requests.map( /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(result) {
                var _window, _window$pagefind, _window2, rawParams, params, query, facetFilters, tagFilters, search, data, pagefindFilters, filterFields, facets;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        rawParams = result.params;
                        params = Object.fromEntries(new URLSearchParams(rawParams));
                        query = params === null || params === void 0 ? void 0 : params.query;
                        facetFilters = (0, _filtersParser.arrToSqlLikeSyntax).apply(void 0, _toConsumableArray((0, _filtersParser.safeParseQueryToJson)(params === null || params === void 0 ? void 0 : params.facetFilters)));
                        tagFilters = (0, _filtersParser.arrToSqlLikeSyntax).apply(void 0, _toConsumableArray((0, _filtersParser.safeParseQueryToJson)(params === null || params === void 0 ? void 0 : params.tagFilters)));
                        _context2.next = 7;
                        return (_window = window) === null || _window === void 0 ? void 0 : (_window$pagefind = _window.pagefind) === null || _window$pagefind === void 0 ? void 0 : _window$pagefind.search(query || null, {
                          filters: _objectSpread({
                            indexName: result.indexName,
                            _tags: (0, _filtersParser.sqlLikeSyntaxToPagefindFilterSyntax)(tagFilters)
                          }, (0, _filtersParser.sqlLikeSyntaxToPagefindFilterSyntax)(facetFilters))
                        });

                      case 7:
                        search = _context2.sent;

                        if (!search) {
                          _context2.next = 14;
                          break;
                        }

                        _context2.next = 11;
                        return Promise.all(search.results.slice(0, constants.maxItemsNumber).map( /*#__PURE__*/function () {
                          var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r) {
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    _context.t0 = (0, _algoliaTransformers.removeIndexPrefixFromUrl);
                                    _context.next = 3;
                                    return r.data();

                                  case 3:
                                    _context.t1 = _context.sent;
                                    return _context.abrupt("return", (0, _context.t0)(_context.t1));

                                  case 5:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));

                          return function (_x3) {
                            return _ref8.apply(this, arguments);
                          };
                        }()));

                      case 11:
                        _context2.t0 = _context2.sent;
                        _context2.next = 15;
                        break;

                      case 14:
                        _context2.t0 = [];

                      case 15:
                        data = _context2.t0;
                        _context2.next = 18;
                        return (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.pagefind.filters();

                      case 18:
                        pagefindFilters = _context2.sent;
                        filterFields = extractFieldsFromQuery(facetFilters);
                        facets = facetFilters.length > 0 ? prepareFacets({
                          fields: filterFields,
                          pagefindFilters: pagefindFilters
                        }) : pagefindFilters;
                        return _context2.abrupt("return", preparePagefindItem({
                          data: data,
                          params: rawParams,
                          query: query || '',
                          facets: facets
                        }));

                      case 22:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x2) {
                return _ref7.apply(this, arguments);
              };
            }()));

          case 5:
            results = _context4.sent;
            return _context4.abrupt("return", {
              results: results
            });

          case 7:
            query = body === null || body === void 0 ? void 0 : body.query;
            facetFilters = (0, _filtersParser.arrToSqlLikeSyntax).apply(void 0, _toConsumableArray((0, _filtersParser.safeParseQueryToJson)(body === null || body === void 0 ? void 0 : body.facetFilters)));
            tagFilters = (0, _filtersParser.arrToSqlLikeSyntax).apply(void 0, _toConsumableArray((0, _filtersParser.safeParseQueryToJson)(body === null || body === void 0 ? void 0 : body.tagFilters)));
            _context4.next = 12;
            return (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$pagefind = _window3.pagefind) === null || _window3$pagefind === void 0 ? void 0 : _window3$pagefind.search(query || null, {
              filters: _objectSpread({
                indexName: algoliaIndexName,
                _tags: (0, _filtersParser.sqlLikeSyntaxToPagefindFilterSyntax)(tagFilters)
              }, (0, _filtersParser.sqlLikeSyntaxToPagefindFilterSyntax)(facetFilters))
            });

          case 12:
            search = _context4.sent;

            if (!search) {
              _context4.next = 19;
              break;
            }

            _context4.next = 16;
            return Promise.all(search.results.slice(0, constants.maxItemsNumber).map( /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(r) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.t0 = (0, _algoliaTransformers.removeIndexPrefixFromUrl);
                        _context3.next = 3;
                        return r.data();

                      case 3:
                        _context3.t1 = _context3.sent;
                        return _context3.abrupt("return", (0, _context3.t0)(_context3.t1));

                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x4) {
                return _ref9.apply(this, arguments);
              };
            }()));

          case 16:
            _context4.t0 = _context4.sent;
            _context4.next = 20;
            break;

          case 19:
            _context4.t0 = [];

          case 20:
            data = _context4.t0;
            _context4.next = 23;
            return (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.pagefind.filters();

          case 23:
            pagefindFilters = _context4.sent;
            filterFields = extractFieldsFromQuery(facetFilters);
            facets = prepareFacets({
              fields: filterFields,
              pagefindFilters: pagefindFilters
            });
            return _context4.abrupt("return", preparePagefindItem({
              data: data,
              params: String(new URLSearchParams(body)),
              query: query || '',
              facets: facets
            }));

          case 27:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function parseToAlgoliaResponse(_x) {
    return _ref6.apply(this, arguments);
  };
}();

var interceptXMLHttpRequest = function interceptXMLHttpRequest() {
  console.log((0, _log.fmt)('Static search interceptor initialized!'));
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (_method, url) {
    this.url = url; // eslint-disable-next-line prefer-rest-params

    originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(body) {
      var _this = this;

      var onResponseReadyStateChange,
          _args6 = arguments;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!isAlgoliaDomain(this.url)) {
                _context6.next = 5;
                break;
              }

              onResponseReadyStateChange = /*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var _window5, newResponse;

                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          if ((_window5 = window) !== null && _window5 !== void 0 && _window5.pagefind) {
                            _context5.next = 5;
                            break;
                          }

                          _context5.next = 3;
                          return new Promise(function (resolve) {
                            return setTimeout(resolve, 100);
                          });

                        case 3:
                          _context5.next = 0;
                          break;

                        case 5:
                          _context5.prev = 5;
                          _context5.t0 = JSON;
                          _context5.next = 9;
                          return parseToAlgoliaResponse({
                            body: body ? JSON.parse(body) : undefined,
                            url: _this.url
                          });

                        case 9:
                          _context5.t1 = _context5.sent;
                          newResponse = _context5.t0.stringify.call(_context5.t0, _context5.t1);
                          Object.defineProperty(_this, 'status', {
                            value: 200,
                            writable: true
                          });
                          Object.defineProperty(_this, 'statusText', {
                            value: 'OK',
                            writable: true
                          });
                          Object.defineProperty(_this, 'responseText', {
                            value: newResponse,
                            writable: true
                          });

                          _this.dispatchEvent(new ProgressEvent('load'));

                          _context5.next = 20;
                          break;

                        case 17:
                          _context5.prev = 17;
                          _context5.t2 = _context5["catch"](5);
                          console.error('Error while modifying response:', _context5.t2);

                        case 20:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, null, [[5, 17]]);
                }));

                return function onResponseReadyStateChange() {
                  return _ref11.apply(this, arguments);
                };
              }();

              _context6.next = 4;
              return onResponseReadyStateChange();

            case 4:
              return _context6.abrupt("return");

            case 5:
              // eslint-disable-next-line prefer-rest-params
              originalSend.apply(this, _args6);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    return function (_x5) {
      return _ref10.apply(this, arguments);
    };
  }();
};

exports.interceptXMLHttpRequest = interceptXMLHttpRequest;